import { Spinner } from "@/components/ui/spinner";
import { cn } from "@/lib/utils";

interface CommonLoadingProps {
  className?: string;
}

export function CommonLoading({ className }: CommonLoadingProps) {
  return (
    <div className="fixed bg-background/50 inset-0 flex items-center justify-center z-50">
      <Spinner className={cn("size-4 animate-spin", className)} />
    </div>
  );
}
